import React from 'react';
import { Target } from 'lucide-react';
import TaskCard from './TaskCard';
import { sortTasksByDate } from '../../utils/taskUtils';

const TaskList = ({ tasks = [], showTimestamps = true, emptyMessage }) => {
  const sortedTasks = sortTasksByDate(tasks);

  if (tasks.length === 0) {
    return emptyMessage ? (
      <div className="text-center py-8 text-gray-400">
        <p className="text-sm">{emptyMessage}</p>
      </div>
    ) : (
      <div className="text-center py-8 text-gray-500">
        <Target className="w-12 h-12 mx-auto mb-4 text-gray-300" />
        <p>No tasks yet. Add your first task above!</p>
      </div>
    );
  }

  return (
    <div>
      {sortedTasks.map(task => (
        <TaskCard 
          key={task.id} 
          task={task} 
          showTimestamp={showTimestamps} 
        />
      ))}
    </div>
  );
};

export default TaskList;